import { ViperSelect } from "@/components";
import { UserSelect } from "@/containers/Project/components";
import { GUTTER_SIZE, RIGHTS } from "@/enums";
import { refType } from "@/propTypes";
import { useUserContext } from "@/providers";
import { useProjectNumberSuggestQuery } from "@/services";
import { Button, Col, Form, Row, Select } from "antd";
import { any, func } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";
const { Option } = Select;

const USER_ID = "userId";
const PROJECT_NUMBER = "projectNumber";

const SearchFilter = ({ form, onFinish, initialValues }) => {
  const { hasRight } = useUserContext();

  const intl = useIntl();
  const [projectNumberQuery, setProjectNumberQuery] = useState({
    [USER_ID]: initialValues?.userToBeReplaced,
    [PROJECT_NUMBER]: null,
  });

  const { data: projectNumberSuggests, isLoading } =
    useProjectNumberSuggestQuery(projectNumberQuery, {
      skip: !projectNumberQuery[PROJECT_NUMBER],
    });

  const handleSuggestInput = (value) => {
    setProjectNumberQuery((prevState) => ({
      ...prevState,
      [PROJECT_NUMBER]: value,
    }));
  };

  const handleUserSelectChange = (value) => {
    setProjectNumberQuery({
      [USER_ID]: value,
      [PROJECT_NUMBER]: null,
    });
  };

  return (
    <Form
      form={form}
      name="userReplacementSearch"
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
    >
      <Row align="bottom" gutter={GUTTER_SIZE.small}>
        <Col style={{ width: 300 }}>
          <Form.Item
            label={intl.formatMessage({ id: "userReplacement.userField" })}
            name="userToBeReplaced"
            required
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "userReplacement.requiredMessage",
                }),
              },
            ]}
          >
            <UserSelect
              multipleSelect={false}
              users={[initialValues?.userToBeReplaced]}
              allowClear
              showDeletedUsers
              onChange={handleUserSelectChange}
              data-test-id="replace-for-user"
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={intl.formatMessage({ id: "userReplacement.projectNumber" })}
            name="projectNumber"
            rules={[
              {
                required: !hasRight([RIGHTS.massReplaceUsers]),
                message: intl.formatMessage({
                  id: "userReplacement.projectNumberRequiredMessage",
                }),
              },
            ]}
          >
            <ViperSelect
              loading={isLoading}
              onFetchSuggestions={handleSuggestInput}
              data-test-id="project-number-select"
              customOptions={projectNumberSuggests?.map((row) => (
                <Option key={row.projectNumber} label={row.projectNumber}>
                  {row.projectNumber}
                </Option>
              ))}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item>
            <Button data-test-id="search-btn" htmlType="submit">
              {intl.formatMessage({ id: "general.search" })}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

SearchFilter.propTypes = {
  form: refType,
  onFinish: func.isRequired,
  initialValues: any,
};

export default SearchFilter;
